import {createAction} from 'redux-actions';
import {curry} from 'ramda';
import tryToCatch from 'try-to-catch';
import {setNotificationAction as setNotification} from '@pluto/notification/Redux/NotificationActions';
import {
    editIngestConfigItem,
    getIngestConfigItemForEditing,
} from '@pluto/rest';

export const INGEST_CONFIG_SET_INITIAL_VALUES_FOR_EDITING = 'INGEST_CONFIG_SET_INITIAL_VALUES_FOR_EDITING';
export const INGEST_CONFIG_RESET_INITIAL_VALUES_FOR_EDITING = 'INGEST_CONFIG_RESET_INITIAL_VALUES_FOR_EDITING';

export const setInitialValuesForEditingItemAction = createAction(INGEST_CONFIG_SET_INITIAL_VALUES_FOR_EDITING, async (id: any) => {
    return await getIngestConfigItemForEditing(id);
});

export const resetInitialValuesForEditingItemAction = createAction(INGEST_CONFIG_RESET_INITIAL_VALUES_FOR_EDITING);

export const editIngestConfigItemAction = curry(async (params, dispatch) => {
    const [error] = await tryToCatch(editIngestConfigItem, params);
    
    if (!error)
        return dispatch(setNotification({
            type: 'success',
            text: 'Config successfully saved',
        }));
    
    const {data: errorData} = error.response;
    
    dispatch(setNotification({
        type: 'error',
        text: errorData.message,
    }));
});
